/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react'
import PropTypes from 'prop-types'

import SubscribeForm from './subscribe-form'
import CheckmarkSvg from '../../content/assets/svgs/checkmark.svg'

const SubscribeModal = ({ handleDismiss, shouldDisplay }) => (
  <div
    className={`fixed z-40 top-0 left-0 flex items-center justify-center w-full h-full modal ${
      shouldDisplay ? '' : 'opacity-0 pointer-events-none'
    }`}
  >
    <div
      role="button"
      tabIndex={-1}
      aria-label="Close"
      className="absolute w-full h-full bg-gray-900 opacity-50 modal-overlay"
      onClick={handleDismiss}
      onKeyPress={handleDismiss}
    />

    <div className="z-50 w-11/12 mx-auto overflow-y-auto bg-white rounded-lg shadow-2xl modal-container md:max-w-xl">
      <div
        role="button"
        tabIndex={-1}
        aria-label="Close"
        onClick={handleDismiss}
        onKeyPress={handleDismiss}
        className="absolute top-0 right-0 z-50 flex flex-col items-center mt-4 mr-4 text-sm text-white cursor-pointer modal-close"
      >
        <svg
          className="text-white fill-current"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
        >
          <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
        </svg>
      </div>
      <div className="flex flex-col items-center justify-center px-6 py-8 text-left md:p-16 modal-content">
        <h3 className="text-2xl font-bold leading-snug text-center md:text-3xl">
          Join 2450+ readers getting a new book every week!
        </h3>
        <ul className="mx-auto mt-8 mb-10 text-lg">
          <li className="flex items-center my-2">
            <CheckmarkSvg className="w-6 h-6 mr-1 text-green-500 fill-current" />
            Best non-fiction books.
          </li>
          <li className="flex items-center my-2">
            <CheckmarkSvg className="w-6 h-6 mr-1 text-green-500 fill-current" />
            Hand-made to read in minutes.
          </li>
          <li className="flex items-center my-2">
            <CheckmarkSvg className="w-6 h-6 mr-1 text-green-500 fill-current" />
            No bullshit, free forever.
          </li>
          <li className="flex items-center my-2">
            <CheckmarkSvg className="w-6 h-6 mr-1 text-green-500 fill-current" />
            Unsubscribe anytime.
          </li>
        </ul>
        <SubscribeForm
          placeholder="Your email address"
          cta="Subscribe to get smarter"
          vertical
        />
      </div>
    </div>
  </div>
)

SubscribeModal.propTypes = {
  handleDismiss: PropTypes.func,
  shouldDisplay: PropTypes.bool,
}

export default SubscribeModal
